/* Cheeky Business overhaul JS (16 Oct 2026). Small, dependency-free. */
(function () {
  // Colour legend shows the picked colour: "Colour: Black" (big-site pattern)
  function legends() {
    document.querySelectorAll('.product-form__input').forEach(function (fs) {
      var dot = fs.querySelector('.cb-dot__input'); if (!dot) return;
      var lg = fs.querySelector('legend'); if (!lg) return;
      var on = fs.querySelector('.cb-dot__input:checked');
      var sp = lg.querySelector('.cb-sel'); if (!sp) { sp = document.createElement('span'); sp.className = 'cb-sel'; lg.appendChild(sp); }
      var v = on ? on.value : ''; if (sp.textContent !== v) sp.textContent = v;   // only write on change, so the observer can't loop
    });
  }
  document.addEventListener('change', function (e) { if (e.target.closest('.product-form__input')) setTimeout(legends, 0); });
  document.addEventListener('DOMContentLoaded', legends);
  // variant-selects re-renders on change: re-run after Shopify swaps the HTML
  new MutationObserver(function (m) { if (m.some(function (x) { return x.target.closest && x.target.closest('variant-selects'); })) legends(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ---- product page: delivery estimate + offer pill under price (16 Oct 2026) ---- */
(function () {
  function addWorkingDays(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function run() {
    var now = new Date(), start = now;
    if (now.getHours() >= 13 || now.getDay() === 0 || now.getDay() === 6) start = addWorkingDays(now, 1);   // after 1pm / weekend: starts next working day
    var a = addWorkingDays(start, 2), b = addWorkingDays(start, 3);
    document.querySelectorAll('[data-cb-eta]').forEach(function (el) { el.textContent = fmt(a) + ' \u2013 ' + fmt(b); });
    var off = document.querySelector('[data-cb-offer]'), price = document.querySelector('.product__info-container .price, .product__info-wrapper .price');
    if (off && price && !document.querySelector('.cb-offer-pill')) {
      var p = document.createElement('p'); p.className = 'cb-offer-pill'; p.innerHTML = off.innerHTML;
      (price.closest('[id^="price-"]') || price).insertAdjacentElement('afterend', p);
    }
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* ---- season countdown (16 Oct 2026): "Order in 9d 4h" next to the order-by date, top bar + product badge ---- */
(function () {
  var D = [{ end: new Date('2026-10-26T13:00:00+00:00'), key: 'Halloween' }, { end: new Date('2026-12-15T13:00:00+00:00'), key: 'Christmas' }];
  function left(t) { var ms = t - Date.now(); if (ms <= 0) return null; var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
    return d > 0 ? d + 'd ' + h + 'h' : h + 'h ' + m + 'm'; }
  function tick() {
    document.querySelectorAll('.cb-announcement span, .cb-announcement b, .cb-season-badge').forEach(function (el) {
      var s = D.find(function (x) { return el.textContent.indexOf(x.key) > -1; }); if (!s) return;
      var l = left(s.end); var c = el.querySelector('.cb-count');
      if (!l) { if (c) c.remove(); return; }
      if (!c) { c = document.createElement('em'); c.className = 'cb-count'; el.appendChild(c); }
      var txt = ' \u00b7 ' + l + ' left'; if (c.textContent !== txt) c.textContent = txt;
    });
  }
  if (document.readyState !== 'loading') tick(); else document.addEventListener('DOMContentLoaded', tick);
  setInterval(tick, 30000);
})();
